import { useSelector } from 'react-redux';
import { userRoleData } from 'redux/slices/userRole';
import { roles } from 'constants/constant';

// Lead gen adds leads and completes the borrower profile of the leads it
// created; components use this to hide everything else.
export default function useIsLeadGen() {
  return useSelector(userRoleData)?.userRole === roles.leadGen;
}
